import { formatter } from '@/services/dateTime/datetimeService';

const defaultFallbackValue = '-';

export default function dateTimeFilter(value, { format, timeZone, fallbackValue } = {}) {
  return formatter(value, format, timeZone, fallbackValue || defaultFallbackValue);
}
